// NOTE This file is auto-generated by Contentlayer

export { isType } from 'contentlayer2/client'

// NOTE During development Contentlayer imports from `.mjs` files to improve HMR speeds.
// During (production) builds Contentlayer it imports from `.json` files to improve build performance.
import allPages from './Page/_index.json' with { type: 'json' }
import allTokens from './Tokens/_index.json' with { type: 'json' }
import allComponents from './Components/_index.json' with { type: 'json' }
import allIcons from './Icons/_index.json' with { type: 'json' }
import allGuides from './Guides/_index.json' with { type: 'json' }
import allGettingStarteds from './GettingStarted/_index.json' with { type: 'json' }
import allStyledSystems from './StyledSystem/_index.json' with { type: 'json' }

export { allPages, allTokens, allComponents, allIcons, allGuides, allGettingStarteds, allStyledSystems }

export const allDocuments = [...allPages, ...allTokens, ...allComponents, ...allIcons, ...allGuides, ...allGettingStarteds, ...allStyledSystems]


